var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96365 17.1949C4.84491 17.1949 4.72623 17.1654 4.61905 17.1071C4.38802 16.9805 4.24414 16.7388 4.24414 16.4754V3.52453C4.24414 3.26118 4.38802 3.01869 4.61905 2.89275C4.84927 2.76612 5.13128 2.77697 5.35293 2.91938L15.4259 9.39491C15.6317 9.52724 15.7561 9.75538 15.7561 9.99998C15.7561 10.2446 15.6317 10.4727 15.4259 10.6051L5.35293 17.0806C5.23417 17.1561 5.09896 17.1949 4.96365 17.1949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.e680e27c10ec2cb7baee4cce3b99f757.svg";
export { ForwardRef as ReactComponent };